import {
  SET_PHONE_CALL_DETAILS,
  SET_DATA_FOR_RECENT_CALLS_TABLE,
  SAVE_DATA_FOR_ACTIVITY,
  SET_TIMELINE_DATA,
  SET_ACTIVITY_ID,
  TIMELINE_DATA_LOADING,
} from './types'

const initialState = {
  phoneCallDetails: {},
  recentCallsData: {},
  activityId: null,
  loading: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_PHONE_CALL_DETAILS:
      return {
        ...state,
        phoneCallDetails: action.payload,
      }
    case SET_DATA_FOR_RECENT_CALLS_TABLE:
      return {
        ...state,
        recentCallsData: action.payload,
      }
    case SAVE_DATA_FOR_ACTIVITY:
      return {
        ...state,
        dataForActivity: action.payload,
      }
    case SET_TIMELINE_DATA:
      return {
        ...state,
        timelineData: action.payload,
      }
    case SET_ACTIVITY_ID:
      return {
        ...state,
        activityId: action.payload,
      }
    case TIMELINE_DATA_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    default:
      return state
  }
}
